<script>
  import { link, push } from 'svelte-spa-router';
  import { auth } from '../lib/auth';
  import { locale, _, isLoading } from 'svelte-i18n';
  import { refreshSettings } from '../stores/settings';
  import { updateLanguage } from '../lib/apiService';
  import { onMount } from 'svelte';
  export let darkMode = true;
  export let toggleTheme = () => {};
  export let user = {id: ''};

  // Get initial language from localStorage or default to 'en'
  const savedLanguage = localStorage.getItem('preferred-language') || 'en';
  locale.set(savedLanguage);

  async function toggleLanguage() {
    const newLocale = $locale === 'nl' ? 'en' : 'nl';
    locale.set(newLocale);
    
    try {
      await updateLanguage(newLocale, (result, status) => {
        if (status === 200) {
          // Language updated successfully, refresh settings to sync the store
          refreshSettings();
        } else {
          console.error('Failed to update language preference:', result);
        }
      });
    } catch (error) {
      console.error('Error updating language:', error);
    }
  }


  onMount(async () => {
    await refreshSettings();
  });
</script>

{#if $isLoading}
  <nav aria-label="Loading...">Loading...</nav>
{:else}
  <nav>
    <ul>
      <li><strong><a href="/" use:link class="brand-text contrast">Pankla</a></strong></li>
    </ul>
    <ul>
      <li>
        <a href="https://pankla.com/hulp" target="_blank" class="contrast theme-toggle px-2">
          <ion-icon name="help-circle-outline" class="pt-2 large"></ion-icon>
        </a>
      </li>
      <li>
        <a href="#" on:click|preventDefault={toggleTheme} class="contrast theme-toggle px-4">
          {#if darkMode}
            <ion-icon name="sunny" class="pt-2"></ion-icon>
          {:else}
            <ion-icon name="moon" class="pt-2"></ion-icon>
          {/if}
        </a>
      </li>
      <li>
        <a href="#" on:click|preventDefault={toggleLanguage} class="outline contrast">
          {$locale === 'en' ? 'NL' : 'EN'}
        </a>
      </li>
      {#if user.id}
      <li>
        <details class="dropdown">
          <summary>
            <ion-icon name="menu-outline" class="pt-1"></ion-icon>
          </summary>
          <ul dir="rtl">
            {#if user.is_superuser}
            <li><a href="/account/#/settings?tab=teams">{$_('nav.teams')}</a></li>
            <li>
              <a href="/account/#/club-settings">
                {$_('settings.club_settings')}
              </a>
            </li>
            {/if}
            <li>
              <a href="/account/#/logout">{$_('settings.logout')}</a>
            </li>
          </ul>
        </details>
      </li>
      {/if}
    </ul>
  </nav>
{/if}

<style>
  @font-face {
    font-family: 'Gagalin';
    src: url('/fonts/gagalin/Gagalin-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  .brand-text {
    font-family: 'Gagalin', sans-serif;
    text-decoration: none;
    font-size: 1.5rem;
  }

  .theme-toggle {
    transition: all 0.2s;
    border-radius: 50%;
  }
  
  .theme-toggle:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  ion-icon.large {
    font-size: 1.5rem;
  }

  details.dropdown summary {
    background-color: transparent;
  }

  details.dropdown summary:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

</style> 